<template>
  <div class="v-divider"></div>
</template>
<script setup>

</script>
<style scoped lang="scss">
.v-divider {
  border-bottom: 1px solid $grey-main;
  margin-bottom: 24px;
  margin-top: 24px;
}
</style>